__turbopack_context__.v({
  "avatarWrapper": "styles-module__rZP0AG__avatarWrapper",
  "name": "styles-module__rZP0AG__name",
  "userInfo": "styles-module__rZP0AG__userInfo",
  "username": "styles-module__rZP0AG__username",
  "wrapper": "styles-module__rZP0AG__wrapper",
});
